import {FormControl} from "@angular/forms";

const validateCprConfig = {
  checkModulus: true,
  cprRegex: /^\d{10}$/,
  cleanupRegex: /-/g,
  daysInMonth: [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31],
  controlNumbers: [4, 3, 2, 7, 6, 5, 4, 3, 2, 1] // via http://da.wikipedia.org/wiki/CPR-nummer#Kontrol_af_personnummer
};

export function validateCPR(c: FormControl) {
  let val = c.value;
  return checkCPRModulus(checkCPR(val)) ? null : {validateCPR: {valid: false}};
}

function checkCPR(val) {
  if (!val) return false;

  let value = (val + '').replace(validateCprConfig.cleanupRegex, '');

  if (validateCprConfig.cprRegex.test(value)) {
    let month = parseInt(value.substring(2, 4));
    if (month === 0 || month > 12) return false; // whether the month is valid

    let day = parseInt(value.substring(0, 2));
    if (day > validateCprConfig.daysInMonth[month - 1]) return false; // whether the day is valid

    return value;
  }

  return false;
}

function checkCPRModulus(val) {
  let components = (val + '').split('');
  let control = validateCprConfig.controlNumbers;
  let sum = 0;

  components.forEach((current, index) => {
    let currentControl = control[index];
    sum += parseInt(current) * currentControl;
  });

  return sum % 11 === 0;
}



// WEBPACK FOOTER //
// ./src/app/core/validators.ts